/**
 * @school/shared/constants - 공통 상수 및 도메인 타입
 *
 * 서버/클라이언트 모두에서 사용하는 공통 타입
 * 런타임 의존성 없음
 */
/**
 * 조직 내 역할
 */
export const ROLE = {
    ADMIN: 'ADMIN',
    TEACHER: 'TEACHER',
};
/**
 * 합류 요청 상태
 */
export const JOIN_REQUEST_STATUS = {
    PENDING: 'pending',
    APPROVED: 'approved',
    REJECTED: 'rejected',
};
/**
 * 성별
 */
export const GENDER = {
    MALE: 'M',
    FEMALE: 'F',
};
/**
 * 조직 타입
 */
export const ORGANIZATION_TYPE = {
    ELEMENTARY: 'ELEMENTARY',
    MIDDLE_HIGH: 'MIDDLE_HIGH',
    YOUNG_ADULT: 'YOUNG_ADULT',
};
/**
 * 타입별 졸업 연령 (한국 나이 기준)
 */
export const MAX_GRADUATION_AGE = {
    ELEMENTARY: 14,
    MIDDLE_HIGH: 20,
    YOUNG_ADULT: null,
};
export const getMaxGraduationAge = (type) => {
    return MAX_GRADUATION_AGE[type];
};
/**
 * 그룹 타입
 */
export const GROUP_TYPE = {
    GRADE: 'GRADE',
    DEPARTMENT: 'DEPARTMENT',
};
export const ORGANIZATION_LABELS_DEFAULT = {
    group: '학년',
    member: '학생',
    groupAndDepartment: '학년&부서',
};
export const ORGANIZATION_LABELS_YOUNG_ADULT = {
    group: '그룹',
    member: '멤버',
    groupAndDepartment: '그룹&부서',
};
export const ORGANIZATION_LABEL_CONFIG = {
    ELEMENTARY: ORGANIZATION_LABELS_DEFAULT,
    MIDDLE_HIGH: ORGANIZATION_LABELS_DEFAULT,
    YOUNG_ADULT: ORGANIZATION_LABELS_YOUNG_ADULT,
};
/**
 * ORGANIZATION_TYPE → 라벨 객체 조회. null/undefined/잘못된 값은 DEFAULT로 안전 fallback.
 */
export const getOrganizationLabels = (type) => {
    if (type && type in ORGANIZATION_LABEL_CONFIG) {
        return ORGANIZATION_LABEL_CONFIG[type];
    }
    return ORGANIZATION_LABELS_DEFAULT;
};
/**
 * 출석 표시 (출석으로 인정되는 마크)
 */
export const PRESENT_MARKS = new Set(['◎', '○', '△']);
/**
 * 개인정보 처리방침 현재 버전
 *
 * 수집 항목/보유기간 등 실질적 변경이 있을 때 증가시킨다.
 * Account.privacyPolicyVersion이 이 값보다 낮으면 소급 재동의가 필요하다.
 *
 * - v1: 2026-02-15 최초 (이름/세례명/성별/나이/연락처/세례일/메모/출석 기록)
 * - v2: 2026-04-24 보호자 연락처 수집 추가 (`student-extra-fields`)
 */
export const CURRENT_PRIVACY_VERSION = 2;
/**
 * 개인정보 처리방침 변경 이력 — `/consent` 재동의 화면에서 노출
 */
export const PRIVACY_POLICY_CHANGELOG = [
    {
        version: 2,
        date: '2026-04-24',
        summary: '학생 보호자 연락처 수집 항목 추가',
    },
];
